import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/interclinic/interclinic/packages/web/app/(main)/NavBarComponent.tsx");
